/**
 * ID numérico de sede para query params (facility_id).
 * localStorage.facility a veces guarda el token encriptado del header;
 * el id real está en Facility (btoa JSON).
 */
export function resolveNumericFacilityId() {
  try {
    const facilityB64 = localStorage.getItem('Facility')
    if (facilityB64) {
      const obj = JSON.parse(atob(facilityB64))
      const id = obj?.id
      if (id != null && /^\d+$/.test(String(id))) {
        return String(id)
      }
    }
  } catch {
    /* ignore */
  }

  const raw = localStorage.getItem('facility')
  if (raw && /^\d+$/.test(String(raw).trim())) {
    return String(raw).trim()
  }

  return ''
}

export function facilityQueryParams(extra = {}) {
  const id = resolveNumericFacilityId()
  if (!id) return { ...extra }
  return { facility_id: id, ...extra }
}

/** Normaliza selección múltiple de sedes para query params. */
export function normalizeFacilitiesId(value) {
  if (value == null || value === '') return []
  return (Array.isArray(value) ? value : [value])
    .map(v => Number(v))
    .filter(v => Number.isFinite(v))
}

/** Params de filtro: vacío = todas las sedes; uno o más = facilities_id[]. */
export function facilitiesFilterParams(value) {
  const ids = normalizeFacilitiesId(value)
  if (!ids.length) return {}
  return { facilities_id: ids }
}
